import { TableFormItem } from "@/containers/ProjectTemplate/styled";
import { IFormFieldOptions } from "@/interfaces";
import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { useEffect, useState } from "react";

interface IProps {
  value: string[];
  options: IFormFieldOptions;
  disabled?: boolean;
  placeholder?: string;
  onChange(data: string[]): void;
}

export const TableMultiSelect = ({
  value,
  options,
  disabled = false,
  placeholder,
  onChange,
}: IProps) => {
  const [convertedOptions, setConvertedOptions] = useState<DefaultOptionType[]>(
    []
  );

  useEffect(() => {
    if (!options) return;

    setConvertedOptions(
      Object.keys(options).map((key) => ({
        value: key,
        label: options[key].fallback,
      }))
    );
  }, [options]);

  return (
    <TableFormItem>
      <Select
        data-test-id="table-multiselect"
        mode="multiple"
        allowClear
        options={convertedOptions}
        defaultValue={value ?? []}
        onChange={(data): void => onChange(data)}
        disabled={disabled}
        placeholder={placeholder}
      />
    </TableFormItem>
  );
};
